const SITE_NAME = "智慧路灯云平台";
const ACCOUNT_MAP = {
    address: '江苏省扬州市高邮市菱塘回族乡兴菱东路30号',
    center: [119.237442, 32.691598]
};
export { SITE_NAME, ACCOUNT_MAP };
